// EU VAT territory: 27 member states
// Unused as we use the "Customs" table to know if it's EU or not
const EU_VAT_ISO_CODES = new Set([
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
]);

export type TvaComponent =
  | "transport"
  | "insurance"
  | "woodBoxes"
  | "membranes";

export type TvaApplications = {
  transport: boolean;
  insurance: boolean;
  woodBoxes: boolean;
  membranes: boolean;
};

export const isInEuVatTerritory = (countryIso: string): boolean =>
  EU_VAT_ISO_CODES.has(countryIso);

// Monaco uses the French VAT system
export const isFrenchVatTerritory = (countryCode: string): boolean =>
  countryCode === "FR" || countryCode === "MC";

export const isTvaApplicable = (
  billingEntityCountry: string,
  isDestinationEU: boolean,
  component: TvaComponent,
): boolean => {
  if (!isFrenchVatTerritory(billingEntityCountry)) return false;
  // Insurance and membranes: TVA applies regardless of destination
  if (component === "insurance" || component === "membranes") return true;
  // Transport and woodBoxes: TVA applies only if destination is in EU
  return isDestinationEU;
};

export const getTvaApplications = (
  billingEntityCountry: string,
  isDestinationEU: boolean,
): TvaApplications => ({
  transport: isTvaApplicable(
    billingEntityCountry,
    isDestinationEU,
    "transport",
  ),
  insurance: isTvaApplicable(
    billingEntityCountry,
    isDestinationEU,
    "insurance",
  ),
  woodBoxes: isTvaApplicable(
    billingEntityCountry,
    isDestinationEU,
    "woodBoxes",
  ),
  membranes: isTvaApplicable(
    billingEntityCountry,
    isDestinationEU,
    "membranes",
  ),
});
